/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { FlatSubtenant } from '@/client';
import { useTheme } from '@/hooks/useTheme';
import { Avatar } from '@/primitives/Avatar';
import { Text } from '@/primitives/Text';
import { tokens } from '@/theme';

export type SubtenantOptionProps = {
  selectedSubtenant?: FlatSubtenant;
  subtenant: FlatSubtenant;
};

export function SubtenantOption({ selectedSubtenant, subtenant }: SubtenantOptionProps) {
  const theme = useTheme();

  const color =
    subtenant.id === selectedSubtenant?.id
      ? { color: theme.antdComponents?.Menu?.itemSelectedColor }
      : { color: theme.antdComponents?.Menu?.itemColor };

  return (
    <div style={{ display: 'flex', gap: 10, padding: '10px 0' }} data-testid={`subtenant-option-${subtenant.id}`}>
      <div style={{ flexGrow: 1, display: 'flex', gap: 10, overflow: 'hidden', maxWidth: '165px' }}>
        <Avatar
          size="xxs"
          text={subtenant.name.charAt(0).toUpperCase()}
          color={tokens.color.gold.gold03}
          backgroundColor={tokens.color.text.textSubtle}
          dataTestId="subtenant-avatar"
          shape="square"
        />
        <Text data-testid="subtenant-name" style={color} ellipsis>
          {subtenant.name}
        </Text>
      </div>
    </div>
  );
}
